module.exports = __webpack_public_path__ + "static/media/BMODE_60_30.192724ac.jpg";